import React from 'react';

import './spinner.scss';

interface Props {}

const Spinner: React.FC<Props> = () => {
    return (
        <div styleName="loader">
            <div styleName="loader__circle">
                <div styleName="loader__container">
                    <div styleName="loader__spinner loader__spinner--orange">
                        <div styleName="loader__spinner loader__spinner--blue">
                            <div styleName="loader__spinner loader__spinner--green" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Spinner;
